export interface RefundSearchCriteria {
    receiptNo: string | null,
    refundType: string | null,
    payOrderNo: string | null,
    counterCustomerID: string | null,
    status: string | null,
    createdDateTimeFrom: Date | null,
    createdDateTimeTo: Date | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_REFUND_SEARCH_CRITERIA: RefundSearchCriteria = {
    receiptNo: null,
    refundType: null,
    payOrderNo: null,
    counterCustomerID: null,
    status: null,
    createdDateTimeFrom: null,
    createdDateTimeTo: null,
}
